import { useTranslation } from "react-i18next";

import { Button } from "../../../components/Button";
import Input from "../../../components/Form/Input/input";
import { FormGroup, Form } from "../../../components/Form/styles";
import { Box } from "../../../components/Layout";
import { RegisterData, RegisterPageProps } from "../types";

const RegisterStep1Page = ({
  data,
  setData,
  onNextStep,
  loading,
  buttonLabel,
  alwaysEnabled = false,
}: RegisterPageProps & {
  setData: (data: RegisterData) => void;
  onNextStep: () => void;
  loading: boolean;
  /** The button's text (default: "Cadastrar usando o e-mail"). */
  buttonLabel?: string;
  /** The button stays on with no e-mail typed; the click then asks for it. */
  alwaysEnabled?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Box className="!mx-0 !mt-0" borderBottom>
      <Form
        className="flex flex-col"
        onSubmit={e => {
          e.preventDefault();
          if (!loading && (alwaysEnabled || data.email)) {
            onNextStep();
          }
        }}>
        <FormGroup>
          <Input
            onChange={e => setData({ ...data, email: e.target.value })}
            label={t("pages.register.form.emailLabel")}
            value={data.email}
            id="email"
            type="email"
            placeholder={t("pages.register.form.emailPlaceholder")}
          />
        </FormGroup>
        <Button
          onClick={onNextStep}
          type="INFO"
          size="LG"
          block
          disabled={loading || (!alwaysEnabled && !data.email)}
          $loading={loading}>
          {buttonLabel ?? t("pages.register.registerButton.button")}
        </Button>
        {/* The visible Button is a styled div; this lets Enter submit the form */}
        <button type="submit" className="sr-only" tabIndex={-1} aria-hidden="true" />
      </Form>
    </Box>
  );
};

export default RegisterStep1Page;
